export const invoiceTypeArr = [
  'platformfee',
  'eor',
  'eordeposit',
  'fixedrate',
] as const;
export type TInvoiceType = (typeof invoiceTypeArr)[number];
